import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
:root {
  font-size: 1px;


  --bg-body: #020617;
  --bg-app-gradient: transparent linear-gradient(90deg, #233a54 0%, #060d19 100%);
  --bg-page: #020617;
  --bg-surface: #131b2d;
  --bg-surface-alt: #1e293b;
  --bg-sidebar: linear-gradient(180deg, rgba(8, 16, 29, 0.98) 0%, rgba(15, 23, 42, 0.96) 22%, rgba(5, 11, 22, 0.98) 100%);
  --bg-sidebar-border: rgba(148, 163, 184, 0.14);
  --bg-sidebar-glow: radial-gradient(circle at top, rgba(14, 165, 233, 0.16), rgba(14, 165, 233, 0));
  --bg-sidebar-divider: linear-gradient(90deg, rgba(15, 23, 42, 0), rgba(71, 85, 105, 0.74), rgba(15, 23, 42, 0));
  --bg-sidebar-item-active: linear-gradient(180deg, rgba(30, 64, 175, 0.68) 0%, rgba(15, 23, 42, 0.92) 100%);
  --bg-sidebar-item-hover: rgba(30, 41, 59, 0.84);
  --border-sidebar-item-active: rgba(96, 165, 250, 0.38);
  --border-sidebar-item-hover: rgba(56, 189, 248, 0.18);
  --shadow-sidebar-item-active: inset 0 1px 0 rgba(191, 219, 254, 0.18), 0 8px 18px rgba(30, 64, 175, 0.2);
  --shadow-sidebar: inset 1px 0 0 rgba(255, 255, 255, 0.05), 18px 0 34px rgba(2, 6, 23, 0.24);
  --bg-header: linear-gradient(180deg, rgba(19, 27, 45, 0.96) 0%, rgba(8, 15, 27, 0.98) 100%);
  --border-header: rgba(71, 85, 105, 0.28);
  --shadow-header: inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 24px 42px rgba(2, 6, 23, 0.28);
  --bg-user-info: linear-gradient(180deg, rgba(19, 27, 45, 0.96) 0%, rgba(8, 15, 27, 0.94) 100%);
  --border-user-info: rgba(71, 85, 105, 0.42);
  --bg-avatar-wrap: linear-gradient(180deg, rgba(30, 64, 175, 0.28) 0%, rgba(15, 23, 42, 0.92) 100%);
  --border-avatar-wrap: rgba(96, 165, 250, 0.22);
  --bg-logout: rgba(15, 23, 42, 0.72);
  --border-logout: rgba(71, 85, 105, 0.52);
  --color-logout: #cbd5e1;
  --bg-input: #0d1526;
  --border-input: #314158;
  --bg-card: #131b2d;
  --border-card: rgba(49, 65, 88, 0.8);
  --shadow-card: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 4px 6px rgba(0, 0, 0, 0.1);
  --bg-footer: #0f172a;
  --border-footer: #1e293b;
  --text-primary: #f8fafc;
  --text-secondary: #e2e8f0;
  --text-muted: #94a3b8;
  --text-placeholder: #64748b;
  --text-heading: #f8fafc;
  --text-button: #cbd5e1;
  --text-reset-color: #fff;
  --bg-scrollbar-track: rgba(15, 23, 42, 0.2);
  --bg-scrollbar-thumb: rgba(71, 85, 105, 0.9);
  --bg-content-viewport: transparent;
  --bg-toggle-track: #314158;
  --bg-toggle-icon: rgba(15, 23, 42, 0.88);
  --bg-button: linear-gradient(180deg, #1e283d 0%, #121a2a 100%);
  --border-button: rgba(49, 65, 88, 0.8);
  --shadow-button: 0px 2px 4px rgba(0, 0, 0, 0.4);
  --switch-shell-bg: #0b1120;
  --switch-panel-bg: #131c30;
  --switch-panel-bg-soft: rgba(19, 28, 48, 0.8);
  --switch-panel-bg-subtle: rgba(19, 28, 48, 0.6);
  --switch-panel-bg-alt: #1b2b44;
  --switch-card-bg: #16213d;
  --switch-input-bg: #0d1526;
  --switch-header-bg: #111a2d;
  --switch-modal-bg: rgba(11, 17, 32, 0.95);
  --switch-border: rgba(29, 41, 61, 0.5);
  --switch-border-strong: rgba(29, 41, 61, 0.72);
  --switch-border-soft: rgba(29, 41, 61, 0.3);
  --switch-scrollbar-thumb: rgba(51, 65, 85, 0.9);
  --switch-text-primary: #ffffff;
  --switch-text-secondary: #cad5e2;
  --switch-text-muted: #90a1b9;
  --switch-text-faint: #62748e;
  --switch-button-bg: linear-gradient(180deg, #1e283d 0%, #192130 100%);
  --switch-button-hover-bg: #1b2b44;
  --switch-chart-grid: rgba(255, 255, 255, 0.16);
  --switch-chart-axis: #ffffff;
  --switch-chart-tick: #cad5e2;
  --switch-empty-bg: rgba(15, 23, 42, 0.6);
  --switch-overlay-bg: rgba(0, 0, 0, 0.5);
  --switch-overlay-strong-bg: rgba(0, 0, 0, 0.7);
  --switch-shadow-soft: 0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -2px rgba(0, 0, 0, 0.1);
  --switch-shadow-popover: 0 8px 24px rgba(0, 0, 0, 0.4);
  --switch-control-track: rgba(51, 65, 85, 0.5);
  --switch-blue-soft: rgba(59, 130, 246, 0.12);
  --switch-blue-subtle: rgba(59, 130, 246, 0.08);
  --switch-blue-border: rgba(59, 130, 246, 0.3);
  --switch-success-soft: rgba(0, 188, 125, 0.1);
  --switch-danger-soft: rgba(238, 75, 86, 0.1);
  --switch-warning-soft: rgba(249, 115, 22, 0.08);
  --legacy-layer-a-start: #1e293b;
  --legacy-layer-a-end: #020617;
  --legacy-layer-a-end-soft: #1f344c;
  --legacy-layer-a-solid: #1e293b;
  --legacy-layer-a-dark: #1e293b;
  --legacy-layer-b: #1b2b44;
  --legacy-layer-b-dark: #1b2b44;
  --legacy-layer-c: #142033;
  --legacy-layer-disabled-start: #475569;
  --legacy-layer-disabled-end: #1d1d1d;
  --legacy-layer-disabled-b: #334155;
  --legacy-layer-disabled-c: #393939;
  --legacy-layer-border: #000000;
  --legacy-layer-shadow: inset 0px 0.5px 1px #ffffff24, 0px 0px 1px #000000;
  --legacy-layer-inset-shadow: inset 0px 0px 3px #000000;
  --legacy-layer-inset-shadow-strong: inset 0px 0px 6px #000000;
  --legacy-layer-inset-shadow-soft: inset 0px 0px 1px #000000;


  --stat-card-bg: #121a2e;
  --stat-card-border: rgba(29, 41, 61, 0.8);
  --stat-card-value: #ffffff;
  --stat-card-label: #ffffff;
  --stat-gauge-track: rgba(226, 232, 240, 0.22);
  --stat-gauge-fill: #2b7fff;
  --stat-total-bg: #5d6732;
  --stat-total-border: #abb32d;
  --stat-total-label: #ffffff;
  --stat-total-value: #ffffff;
}

:root.light {
  --bg-body: #f9fafb;
  --bg-app-gradient: #f9fafb;
  --bg-page: #f9fafb;
  --bg-surface: #ffffff;
  --bg-surface-alt: #f3f4f6;
  --bg-sidebar: #f9fafb;
  --bg-sidebar-border: #e5e7eb;
  --bg-sidebar-glow: none;
  --bg-sidebar-divider: linear-gradient(90deg, rgba(229, 231, 235, 0), rgba(209, 213, 219, 0.74), rgba(229, 231, 235, 0));
  --bg-sidebar-item-active: rgba(43, 127, 255, 0.1);
  --bg-sidebar-item-hover: rgba(243, 244, 246, 0.84);
  --border-sidebar-item-active: rgba(43, 127, 255, 0.2);
  --border-sidebar-item-hover: rgba(209, 213, 219, 0.5);
  --shadow-sidebar-item-active: inset 0 0 12px rgba(59, 130, 246, 0.1);
  --shadow-sidebar: none;
  --bg-header: #ffffff;
  --border-header: #e5e7eb;
  --shadow-header: 0 1px 3px rgba(0, 0, 0, 0.06);
  --bg-user-info: #ffffff;
  --border-user-info: #e5e7eb;
  --bg-avatar-wrap: #f3f4f6;
  --border-avatar-wrap: #e5e7eb;
  --bg-logout: #f3f4f6;
  --border-logout: #e5e7eb;
  --color-logout: #4a5565;
  --bg-input: #f3f4f6;
  --border-input: #e5e7eb;
  --bg-card: #ffffff;
  --border-card: #e5e7eb;
  --shadow-card: 0px 1px 1.5px rgba(0, 0, 0, 0.1), 0px 1px 1px rgba(0, 0, 0, 0.1);
  --bg-footer: #ffffff;
  --border-footer: #e5e7eb;
  --text-primary: #1e2939;
  --text-secondary: #364153;
  --text-muted: #6a7282;
  --text-placeholder: #99a1af;
  --text-heading: #1e2939;
  --text-button: #4a5565;
  --text-reset-color: #1e2939;
  --bg-scrollbar-track: rgba(243, 244, 246, 0.5);
  --bg-scrollbar-thumb: rgba(156, 163, 175, 0.5);
  --bg-content-viewport: transparent;
  --bg-toggle-track: #e5e7eb;
  --bg-toggle-icon: #f3f4f6;
  --bg-button: #f3f4f6;
  --border-button: #e5e7eb;
  --shadow-button: none;
  --switch-shell-bg: #ffffff;
  --switch-panel-bg: #ffffff;
  --switch-panel-bg-soft: rgba(255, 255, 255, 0.92);
  --switch-panel-bg-subtle: rgba(249, 250, 251, 0.86);
  --switch-panel-bg-alt: #f3f6fb;
  --switch-card-bg: #ffffff;
  --switch-input-bg: #f8fafc;
  --switch-header-bg: #ffffff;
  --switch-modal-bg: rgba(255, 255, 255, 0.98);
  --switch-border: #e5e7eb;
  --switch-border-strong: #d1d5db;
  --switch-border-soft: #eef2f7;
  --switch-scrollbar-thumb: rgba(148, 163, 184, 0.55);
  --switch-text-primary: #111827;
  --switch-text-secondary: #334155;
  --switch-text-muted: #64748b;
  --switch-text-faint: #94a3b8;
  --switch-button-bg: #f3f6fb;
  --switch-button-hover-bg: #e8eef7;
  --switch-chart-grid: rgba(148, 163, 184, 0.28);
  --switch-chart-axis: #64748b;
  --switch-chart-tick: #475569;
  --switch-empty-bg: rgba(248, 250, 252, 0.88);
  --switch-overlay-bg: rgba(15, 23, 42, 0.24);
  --switch-overlay-strong-bg: rgba(15, 23, 42, 0.4);
  --switch-shadow-soft: 0px 1px 2px rgba(15, 23, 42, 0.06);
  --switch-shadow-popover: 0 18px 40px rgba(15, 23, 42, 0.14);
  --switch-control-track: rgba(203, 213, 225, 0.85);
  --switch-blue-soft: rgba(59, 130, 246, 0.1);
  --switch-blue-subtle: rgba(59, 130, 246, 0.06);
  --switch-blue-border: rgba(59, 130, 246, 0.24);
  --switch-success-soft: rgba(0, 188, 125, 0.12);
  --switch-danger-soft: rgba(238, 75, 86, 0.1);
  --switch-warning-soft: rgba(249, 115, 22, 0.1);
  --legacy-layer-a-start: #ffffff;
  --legacy-layer-a-end: #eef2f7;
  --legacy-layer-a-end-soft: #f8fafc;
  --legacy-layer-a-solid: #f8fafc;
  --legacy-layer-a-dark: #eef2f7;
  --legacy-layer-b: #e8eef7;
  --legacy-layer-b-dark: #e2e8f0;
  --legacy-layer-c: #f1f5f9;
  --legacy-layer-disabled-start: #e5e7eb;
  --legacy-layer-disabled-end: #cbd5e1;
  --legacy-layer-disabled-b: #d1d5db;
  --legacy-layer-disabled-c: #cbd5e1;
  --legacy-layer-border: #cbd5e1;
  --legacy-layer-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.86), 0px 1px 2px rgba(15, 23, 42, 0.08);
  --legacy-layer-inset-shadow: inset 0px 0px 0px 1px rgba(148, 163, 184, 0.12);
  --legacy-layer-inset-shadow-strong: inset 0px 0px 0px 1px rgba(148, 163, 184, 0.2), 0px 1px 2px rgba(15, 23, 42, 0.06);
  --legacy-layer-inset-shadow-soft: inset 0px 0px 0px 1px rgba(148, 163, 184, 0.12);


  --stat-card-bg: #f3f4f6;
  --stat-card-border: #e5e7eb;
  --stat-card-value: #1e2939;
  --stat-card-label: #6a7282;
  --stat-gauge-track: #d1d5db;
  --stat-gauge-fill: #1d4ed8;
  --stat-total-bg: #f0fdf4;
  --stat-total-border: rgba(34, 197, 94, 0.8);
  --stat-total-label: #166534;
  --stat-total-value: #1e2939;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  background-color: var(--bg-body);
  transition: background-color 0.3s ease;


  font-family: 'Inter', sans-serif;

  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    color: var(--text-reset-color);
  }

  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }

  body {
    line-height: 1.5;
  }

  button {
    outline: none;
    border: none;
    cursor: pointer;
    background-color: transparent;
    margin: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;
    color: var(--text-reset-color);
  }

  *:focus {
    outline: none;
  }

  input, textarea {
    border: none;
    text-align: center;
    font-family: 'Inter', sans-serif;
    color: var(--text-reset-color);
    ::placeholder {
      font-family: 'Inter', sans-serif;
    }
  }

  ol, ul, li {
    list-style: none;
    padding: 0;
  }

  blockquote, q {
    quotes: none;
  }

  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  input:focus {
    outline: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
`;

export default GlobalStyle;
